"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusAPI = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
/**
 * 简易合约发财经 API
 */
var BonusAPI;
(function (BonusAPI) {
    /**
     * 获取用户发财金
     * @returns 发财金信息
     */
    function getBonus() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + "/bonus/";
        return trade_utils_lib_1.Network.get({
            url,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    BonusAPI.getBonus = getBonus;
    /**
     * 获取单个发财金详细信息
     * @param id 发财金 ID
     * @returns 发财金详细信息 BonusDetailResponse
     */
    function getDetail(id) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/${id}/`;
        return trade_utils_lib_1.Network.get({
            url,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    BonusAPI.getDetail = getDetail;
    /**
     * 获取用户发财金使用记录
     * @param page 分页token，可选
     * @param type 发财金类型
     * @returns 发财金使用记录
     */
    function getRecords(type, page) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + "/bonus/records/";
        return trade_utils_lib_1.Network.get({
            url,
            data: Object.assign({ support_type: type }, (page
                ? {
                    page_token: page,
                }
                : {})),
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    BonusAPI.getRecords = getRecords;
})(BonusAPI = exports.BonusAPI || (exports.BonusAPI = {}));
